import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-595c95c6")

_pushScopeId("data-v-595c95c6")
const _hoisted_1 = { class: "flex gap-x-4 w-full justify-center py-4 border-l border-gray-lp-400" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_TimeRangePicker = _resolveComponent("TimeRangePicker")!

  return (_openBlock(), _createBlock(_component_TimeRangePicker, {
    ref: "courier-pickup-download-time-range-picker",
    class: "download-courier-pickup-calendar",
    startDate: _ctx.date.startDate,
    endDate: _ctx.date.endDate,
    onSelect: _ctx.setDateRange,
    default: _ctx.$t('custom'),
    isSetMaxDate: "",
    customTotalMaxDate: _ctx.maxRange - 1,
    maxDate: new Date(),
    showOptions: 
      `${_ctx.$t('custom')}, ${_ctx.$t('7 hari terakhir')}, ${_ctx.$t(
        '14 hari terakhir'
      )}, ${_ctx.$t('30 hari terakhir')}`
    ,
    advanceStyle: {
      width: '550px',
      fontSize: 'text-sm',
      fontWeight: 'font-medium'
    },
    isConvertName: "",
    title: _ctx.$t('pickupDashboard.dateRangeTitle'),
    labelCustom: _ctx.$t('pickupDashboard.dateRangeTitle'),
    isResetOnChangeOption: "",
    leftPosition: false
  }, {
    trigger: _withId(() => [
      _createVNode(_component_LpButton, {
        outline: "",
        title: _ctx.resolvedButtonText,
        textColor: "red-lp-100",
        iconV2: "",
        "icon-left": "download-new",
        iconColor: "red-lp-100",
        iconGroupHoverColor: _ctx.disabled ? 'text-gray-lp-600' : '',
        disabled: _ctx.disabled
      }, null, 8, ["title", "iconGroupHoverColor", "disabled"])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_LpButton, {
          outline: "",
          title: _ctx.$t('pickupDashboard.reset'),
          textColor: "red-lp-100",
          iconColor: "red-lp-100",
          onClick: _ctx.onReset
        }, null, 8, ["title", "onClick"]),
        _createVNode(_component_LpButton, {
          title: _ctx.$t('pickupDashboard.downloadData'),
          textColor: "white",
          onClick: _ctx.onDownload,
          disabled: !_ctx.date.startDate || !_ctx.date.endDate
        }, null, 8, ["title", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["startDate", "endDate", "onSelect", "default", "customTotalMaxDate", "maxDate", "showOptions", "title", "labelCustom"]))
})